import { RefObject, useCallback, useMemo, useState } from "react";
import { usePointerDown } from "./usePointerDown";
import { usePointerEnter } from "./usePointerEnter";

export type PointerState = {
  isDown: boolean;
  isInside: boolean;
};

export const usePointerState = (ref: RefObject<HTMLElement>): PointerState => {
  const [isDown, setIsDown] = useState(false);
  const [isInside, setIsInside] = useState(false);

  const downHandler = useCallback(() => {
    setIsDown(true);
  }, [setIsDown]);

  const upHandler = useCallback(() => {
    setIsDown(false);
  }, [setIsDown]);

  usePointerDown({ ref, callback: downHandler, reverseCallback: upHandler });

  const enterHandler = useCallback(() => {
    setIsInside(true);
  }, [setIsInside]);

  const leaveHandler = useCallback(() => {
    setIsInside(false);
  }, [setIsInside]);

  usePointerEnter({
    ref,
    callback: enterHandler,
    reverseCallback: leaveHandler,
  });

  return useMemo(
    () => ({
      isDown,
      isInside,
    }),
    [isDown, isInside]
  );
};
